import PropTypes from 'prop-types';
import React from 'react';
import SessionStore from 'stores/shared/session';
import { loadLocales } from 'services/translation';
import { FormattedMessage, injectIntl } from 'react-intl';
import _ from 'underscore';

import './index.scss';

class GlobalError extends React.PureComponent {
  static displayName = 'GlobalError-Plugins';

  static propTypes = {
    statusCode: PropTypes.number,
    statusMessages: PropTypes.object,
    defaultErrorMessage: PropTypes.string,
    showButton: PropTypes.bool,
    intl: PropTypes.object.isRequired,
  };

  static defaultProps = (function () {
    return {
      statusCode: null,
      showButton: true,
    };
  })();

  UNSAFE_componentWillMount() {
    const languageParam = new URL(window.location.href).searchParams.get(
      'lang'
    );
    loadLocales(languageParam || SessionStore.state.get('i18n'));
  }

  messageForStatus = () => {
    const { intl, statusMessages } = this.props;
    const errorMessage = `${intl.formatMessage({
      id: 'SOMETHING_WENT_WRONG_WHEN_TRYING_TO_PROCESS_YOUR_REQUEST',
      defaultMessage:
        'Something went wrong when trying to process your request',
    })}.`;

    return _.extend(
      {
        404: errorMessage,
        410: errorMessage,
      },
      statusMessages
    );
  };

  _errorMessage = () => {
    const { intl, statusCode } = this.props;
    const defaultErrorMessage = `${intl.formatMessage({
      id: 'SOMETHING_WENT_WRONG_WHEN_TRYING_TO_PROCESS_YOUR_REQUEST',
      defaultMessage:
        'Something went wrong when trying to process your request',
    })}.`;
    return (
      this.messageForStatus()[statusCode] || defaultErrorMessage
    );
  };

  _handleClick = (e) => {
    e.preventDefault();
    location.reload();
  };

  _renderButton = () => {
    return (
      <div className="GlobalError-ButtonContainer">
        <a href="#" onClick={this._handleClick} className="ui button brand-bg">
          <FormattedMessage id="REFRESH" defaultMessage="Refresh" />
        </a>
      </div>
    );
  };

  render() {
    return (
      <div className="GlobalError-Container">
        <div className="GlobalError-Message">
          <h1>
            <span className="text">
              <FormattedMessage id="OOPS" defaultMessage="Oops" />!
            </span>
            <span className="icon af-globalerror brand-color" />
          </h1>
          <p>{this._errorMessage()}</p>
          <p>
            <FormattedMessage
              id="PLEASE_REFRESH_YOUR_PAGE_AND_TRY_AGAIN"
              defaultMessage="Please refresh your page and try again"
            />
            .
          </p>
        </div>
        {this.props.showButton && this._renderButton()}
      </div>
    );
  }
}

export default injectIntl(GlobalError);
